module.exports = __webpack_public_path__ + "img/edit.01069ca6.svg";